import { render } from "./CheckupRecord.vue?vue&type=template&id=8077eafc"
import script from "./CheckupRecord.vue?vue&type=script&lang=js"
export * from "./CheckupRecord.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__